import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {PostmethodService} from '../app-config/postmethod.service';
import {RequestModel} from 'src/app/models/RequestModel';
@Injectable({
  providedIn: 'root',
})
export class SharedService {
  constructor(private ws: PostmethodService) {}

  getAllcities(request: RequestModel, iv: string) {
    return this.ws.wsPost(
      request,
      environment.commonServiceUrl + 'getCityMaster',
      iv,
    );
  }

  getAllCenter(request: RequestModel, iv: string) {
    return this.ws.wsPost(
      request,
      environment.commonServiceUrl + 'getcenter',
      iv,
    );
  }

  getAllState(request: RequestModel, iv: string) {
    return this.ws.wsPost(
      request,
      environment.commonServiceUrl + 'getStateMaster',
      iv,
    );
  }

  getUserType(request: RequestModel, iv: string) {
    return this.ws.wsPost(
      request,
      environment.commonServiceUrl + 'getUserType',
      iv,
    );
  }

  getRoles(request: RequestModel, iv: string) {
    return this.ws.wsPost(
      request,
      environment.commonServiceUrl + 'getRole',
      iv,
    );
  }

  getRazorpaysDetails(request: RequestModel, iv: string) {
    return this.ws.wsPost(
      request,
      environment.MobileServiceUrl + 'insertCallBackUrlDetails',
      iv,
    );
  }

  allowNumbersOnly(event: any) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  allowAlphabetsOnly(event: any) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[a-zA-Z\s]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  toLowerKeys(obj: {[x: string]: any}) {
    return Object.keys(obj).reduce((accumulator: any, key) => {
      accumulator[key.toLowerCase()] = obj[key];
      return accumulator;
    }, {});
  }

  formatDateToDDMMYYYY(timestamp: any) {
    const date = new Date(timestamp);

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return new Date(year, month - 1, day);
  }

  convertToYYYYMMDD(dateString:any) {
    const date = new Date(dateString);
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
  
    return `${year}-${month}-${day}`;
  }
}
